import type { InputHTMLAttributes, ReactNode } from 'react';
import { Icon } from '../Icon';

import styles from './Radio.module.css';

export type RadioSize = 'large' | 'default' | 'small';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange' | 'size' | 'type'> {
  /** Figma Border=on：带边框的卡片式单选项。 */
  border?: boolean;
  /** 自定义内容（如 label 后内嵌输入框）；提供后不再渲染 `label` 文本。 */
  children?: ReactNode;
  checked: boolean;
  label?: string;
  onCheckedChange: (checked: boolean) => void;
  size?: RadioSize;
  /** 卡片单选：只提供边框和右上角勾，内容由调用方传入。 */
  variant?: 'default' | 'card';
}

export function Radio({ border = false, checked, children, className, disabled, label, onCheckedChange, size = 'default', variant = 'default', ...inputProps }: RadioProps) {
  return (
    <label
      className={[styles.root, className].filter(Boolean).join(' ')}
      data-border={border || undefined}
      data-checked={checked || undefined}
      data-disabled={disabled || undefined}
      data-size={size}
      data-variant={variant}
    >
      <input
        {...inputProps}
        checked={checked}
        className={styles.control}
        disabled={disabled}
        onChange={(event) => onCheckedChange(event.target.checked)}
        type="radio"
      />
      {variant === 'default' ? <span aria-hidden="true" className={styles.indicator} /> : null}
      {children ?? <span className={styles.label}>{label}</span>}
      {variant === 'card' && checked ? <span aria-hidden="true" className={styles.selectionMark}><Icon name="select" size="sm" /></span> : null}
    </label>
  );
}
